import React, { useState, useEffect, useContext } from 'react'
import DOMPurify from 'dompurify'
import { GlobalContext } from '../../../utility'
import {
  isInstitutional,
  isInvestorAdvisorOrInstitutional,
} from '../../../../global/authentication/authentication-manager'
import './breadCrumbs.css'

export const mapLocalToProdPath = (pathName) => {
  const pathNames = ['/cti-site/blogspa', '/blogspa/preview', '/blogspa']

  const replaceThis = pathNames.find((path) => {
    return pathName.startsWith(path)
  })

  return replaceThis ? pathName.replace(replaceThis, '/insights') : pathName
}

export const getLeafCrumb = (currentUrl, displayName) => {
  return /\/insights\/latest-insights\/+./.test(currentUrl) ||
    (/\/insights\/market-perspectives\/+./.test(currentUrl) && displayName)
    ? {
        name: displayName,
        url: null,
      }
    : null
}

const Chevron = () => {
  return (
    <span className="Icon--material u-textSizeMsrp1 u-posRelative chevron">
      chevron_right
    </span>
  )
}

export const HomeLink = ({ env }) => {
  const envLinks = {
    institutional: '/institutional',
    investor: '/investor',
    advisor: '/',
  }
  const link = envLinks[env]

  return (
    <>
      <div>
        <a className="u-textSizeMsrm1 u-textColorBrandLight" href={link}>
          Home
        </a>
      </div>
      <Chevron />
    </>
  )
}

export const getBreadcrumbs = (currentUrl, items, info) => {
  if (isInstitutional()) {
    currentUrl = currentUrl
      .replace('/institutional', '')
      .replace('/cti-site/cti-institutional', '')
  }

  if (!info) {
    info = { found: false, breadcrumbs: [] }
  }

  items.forEach((item) => {
    if (info.found) {
      return
    }

    const _url = item.getUrl()?.split('?')[0]

    // Don't add breadcrumb for Home (e.g. '/')
    if (_url && _url !== '/' && currentUrl.indexOf(_url) > -1) {
      info.breadcrumbs.push({
        name: item.getName(),
        // DEV NOTE: For some insane reason, parameters on a parent are also on the children, so we set the value to match the item's 'hst:referencesitemapitem'
        url:
          _url === currentUrl ||
          item.getParameters()?.unlinked ===
            (item?.model?.properties['hst:referencesitemapitem'] ||
              item?.model?.properties['hst:externallink'])
            ? null
            : item.getUrl(),
      })
    }

    if (_url === currentUrl) {
      info.found = true

      return
    }

    const children = item.getChildren()

    if (children.length > 0) {
      info = getBreadcrumbs(currentUrl, children, info)
    }
  })

  return info
}
export const BreadCrumbs = ({ page, menu }) => {
  const { setBreadcrumbsGlobal } = useContext(GlobalContext)
  const [breadcrumbs, setBreadcrumbs] = useState([])

  const currentUrl = window.location.pathname

  const isMarketPages = currentUrl.includes('/insights/market-perspectives')
  let displayName = ''

  if (isMarketPages) {
    displayName = page?.getDocument()?.model?.data?.displayName
  } else {
    displayName =
      page?.getDocument()?.model?.data?.title ||
      page?.getDocument()?.model?.data?.displayName
  }

  const env = isInvestorAdvisorOrInstitutional()

  useEffect(() => {
    const mappedUrl = mapLocalToProdPath(currentUrl)
    const _breadcrumbs = getBreadcrumbs(mappedUrl, menu?.getItems())
    const leaf = getLeafCrumb(mappedUrl, displayName)
    if (leaf) {
      _breadcrumbs.breadcrumbs.push(leaf)
    }
    setBreadcrumbsGlobal(_breadcrumbs.breadcrumbs || [])
    setBreadcrumbs(_breadcrumbs.breadcrumbs || [])
  }, [page, document])

  const envLinks = {
    institutional: '/institutional',
    investor: '/investor',
    advisor: '',
  }
  const basePath = envLinks[env] || ''

  return (
    breadcrumbs &&
    breadcrumbs.length > 0 && (
      <div className="u-bgColorWhite BlogBreadCrumbs">
        <div className="u-sizeConstrained u-flex u-flexAlignItemsCenter">
          <div className="u-flex u-flexAlignItemsCenter u-sizeFull u-borderTop u-paddingVert3gu">
            <HomeLink env={env} />
            {breadcrumbs.map((breadcrumb, index) => {
              return (
                <React.Fragment key={index}>
                  {index > 0 && <Chevron />}
                  <div>
                    {breadcrumb.url ? (
                      <a
                        className="u-textSizeMsrm1 u-textColorBrandLight"
                        href={`${basePath}${DOMPurify.sanitize(
                          breadcrumb.url
                        )}`}
                      >
                        {breadcrumb.name}
                      </a>
                    ) : (
                      <div className="u-textSizeMsrm1 u-textColorDefault">
                        {breadcrumb.name}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )
            })}
          </div>
        </div>
      </div>
    )
  )
}
